export function parseYouTube(url) {
  if (!url) return null;
  const u = String(url).trim();
  if (!/youtu\.?be/i.test(u)) return null;
  let m;
  let id = null;
  if ((m = u.match(/[?&]v=([\w-]{6,})/))) id = m[1];
  else if ((m = u.match(/youtu\.be\/([\w-]{6,})/))) id = m[1];
  else if ((m = u.match(/youtube(?:-nocookie)?\.com\/(?:embed|live|shorts|v)\/([\w-]{6,})/))) id = m[1];
  const list = (u.match(/[?&]list=([\w-]+)/) || [])[1] || null;
  if (!id && !list) return null;
  // Auto-generated mixes (RD...) are endless; play only the chosen video.
  return { id, list: list && !(id && list.startsWith("RD")) ? list : null };
}

let ytPromise = null;
export function loadYouTubeApi() {
  if (window.YT && window.YT.Player) return Promise.resolve(window.YT);
  if (!ytPromise) {
    ytPromise = new Promise((resolve) => {
      const prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        if (prev) prev();
        resolve(window.YT);
      };
      const s = document.createElement("script");
      s.src = "https://www.youtube.com/iframe_api";
      s.async = true;
      document.head.appendChild(s);
    });
  }
  return ytPromise;
}
